const contractor_userRouter = [
    {
        path: "list-contractor-user",
        name: "contractorUser",
        component: () => import("@/views/admin/contractor_user"),
        default: true,
        meta: {
            model: "contractor_user",
            // requiresAuth: true,
        },
    },
    {
        path: "list-contractor-user/add",
        name: "addContractorUser",
        component: () => import("@/views/admin/contractor_user/function"),
        default: true,
        meta: {
            model: "contractor_user",
            // requiresAuth: true,
        },
    },
    {
        path: "list-contractor-user/edit/:id",
        name: "editContractorUser",
        component: () => import("@/views/admin/contractor_user/function"),
        default: true,
        meta: {
            model: "contractor_user",
            // requiresAuth: true,
        },
    },
    {
        path: "list-contractor-user/violation/:id",
        name: "contractorUserViolation",
        component: () => import("@/views/admin/contractor_user/violation"),
        default: true,
        meta: {
            model: "contractor_user_violation",
            // requiresAuth: true,
        },
    },
];
export default contractor_userRouter;